import React from "react";
import { useLang } from "../context/LanguageContext";

export default function Collective() {
  const { t } = useLang();
  const tags = [...t.collective.marquee, ...t.collective.marquee];

  return (
    <section
      id="collective"
      data-testid="collective-section"
      className="relative bg-[#0A0A0A] py-24 md:py-32 overflow-hidden border-t border-white/5"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-4">
            <p className="font-mono-tight text-zinc-500 mb-6">{t.collective.label}</p>
            <h2
              className="text-5xl md:text-7xl font-display tracking-tighter text-white"
              data-testid="collective-title"
            >
              {t.collective.title}
              <span className="block font-editorial italic font-light text-zinc-400">
                {t.collective.title_2}
              </span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8 flex items-end">
            <p className="text-zinc-400 text-lg leading-relaxed" data-testid="collective-sub">
              {t.collective.sub}
            </p>
          </div>
        </div>

        {/* Roles grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-white/10">
          {t.collective.roles.map((r) => (
            <div
              key={r.role}
              data-testid={`role-card-${r.role.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
              className="group p-8 md:p-10 border-b border-white/10 lg:border-b-0 lg:border-r border-white/10 last:border-r-0 transition-colors hover:bg-white/[0.02]"
            >
              <div className="flex items-baseline gap-4 mb-8">
                <span className="text-7xl md:text-8xl font-display chrome-text leading-none">{r.count}</span>
                <span className="font-mono-tight text-zinc-600">members</span>
              </div>
              <div className="text-2xl md:text-3xl text-white mb-3">{r.role}</div>
              <p className="text-sm text-zinc-500 leading-relaxed">{r.detail}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Marquee */}
      <div className="mt-20 md:mt-28 overflow-hidden border-y border-white/10 py-8">
        <div className="marquee whitespace-nowrap">
          {tags.map((tag, i) => (
            <span
              key={`marquee-${tag}-${i}`}
              className="text-5xl md:text-7xl font-editorial italic font-light text-zinc-700 mx-8 hover:text-white transition-colors"
            >
              {tag} <span className="text-zinc-800 mx-4">✦</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
